export default "__VITE_ASSET__CBb1Rmz5__"